<div>
  <mat-label>
    <h1>Fund Accounts</h1>
  </mat-label>
  <div class="mt-30">
    <h3>{{ transferFundsTitle }}</h3>
    <p>{{ transferFundsDescription }}</p>
  </div>
  <div>
    <mat-radio-group (change)="onFundAccountNow($event)">
      <mat-radio-button [value]="true">Fund Now</mat-radio-button>
      <mat-radio-button [value]="false">Fund Later</mat-radio-button>
    </mat-radio-group>
  </div>
  <p class="mt-30">{{ fundingTerms }}</p>
</div>
